/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useContext, FC } from 'react'
import { Box, Typography, CircularProgress } from '@material-ui/core'
import API from '@aws-amplify/api'
import { useHistory } from 'react-router-dom'
import { SignupContext } from '../../context/SignupContextContainer'
import SignupLayout from '../../layout'
import SIGNUP_STEPS from '../../utils/constants'
import MemberShip from '../Dashboard/Settings/MemberShip'
import '../Dashboard/Settings/styles.scss'

const Billing: FC = () => {
  const { user, setSignupStep } = useContext(SignupContext)
  const userInfo: any | null = user
  const history = useHistory()

  const [userEmail, setUserEmail] = React.useState()
  const [licenseType] = React.useState('personal')
  const [isLoading, setIsLoading] = React.useState(true)
  const [billingTerms, setBillingTerms] = React.useState('Yearly')

  const subscribeToProductPlan = async (token, productPlan): Promise<void> => {
    setIsLoading(true)
    const bodyParams = {
      stripeToken: token.id,
      email: token.email,
      licenseRecipient: {
        email: userEmail,
        type: licenseType,
      },
      productPlan,
    }

    const myInit = {
      body: bodyParams,
    }

    try {
      await API.post('mav-outlook-api', '/users/billing', myInit)
      setSignupStep(SIGNUP_STEPS.PROSPECT)
      history.push('/client/prospect')
    } catch (e) {
      console.error(e)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (userInfo && userInfo?.attributes) {
      setUserEmail(userInfo?.attributes.email)
    }
    setIsLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo])

  return (
    <SignupLayout>
      {isLoading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        <div className="billing">
          <Typography variant="h3" className="billing-title">
            CHOOSE YOUR FLIGHT PLAN
          </Typography>
          <MemberShip
            subscribeToProductPlan={subscribeToProductPlan}
            billingTerms={billingTerms}
            setBillingTerms={setBillingTerms}
          />
        </div>
      )}
    </SignupLayout>
  )
}

export default Billing
